type QueryObjectValue = string | number | boolean

interface QueryObject {
  [key: string]: QueryObjectValue
}

const toString = (o: QueryObject): string => {
  return Object.keys(o)
    .reduce<string[]>((acc, cur) => {
      acc.push([cur, o[cur]].join('='))
      return acc
    }, [])
    .join('&')
}

export const queryString = {
  toString
}
